export function map<T, U>(collection: T[], transformer: (item: T) => U): U[] {
  return collection.map(transformer)
}
